export default [
  {
    path: '/mobile/login',
    name: 'mobile-login',
    component: () => import('@/views/mobile/login/Login.vue'),
    meta: {
      layout: 'mobile',
      isLogin: true,
      notNeedProgress: true,
      title: '登录',
    },
  },
  {
    path: '/mobile/login/secondary-auth',
    name: 'mobile-login-secondary-auth',
    component: () => import('@/views/mobile/login/SecondaryAuth.vue'),
    meta: {
      layout: 'mobile',
      isLogin: true,
      notNeedProgress: true,
      title: '短信二认证',
    },
  },
  {
    path: '/mobile/login/bind-account-for-login',
    name: 'mobile-login-bind-account-for-login',
    component: () => import('@/views/mobile/login/BindAccountForLogin.vue'),
    meta: {
      layout: 'mobile',
      isLogin: true,
      notNeedProgress: true,
      title: '绑定账号',
    },
  },
];
